
import { computed, defineComponent, onMounted, ref, inject  } from "vue";
import { store } from "@/store";
const language = window.localStorage.getItem('language');

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
      default: "Nationality",
    },
    formProp: {
      type: String,
      required: true,
      default: "nationality",
    },
    modelValue: {
      type: String,
      required: true,
      default: "",
    },
    placeHolder: {
      type: String,
      required: false,
      default: language == 'ar' ? 'تحديد' : 'Select',
    },
    tooltipMessage: {
      type: String,
      required: false,
      default: "",
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    insuranceProviderId: {
      type: Number,
      required: false,
      default: 0,
    },
    inboundDestinationId: {
      type: Number,
      required: false,
      default: 0,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },

  setup(_, context) {
    const isGts = ref(process.env.VUE_APP_GTS_INSURANCE_ID);

    const countries = computed(() => {

      let allCountries = store.state.countries.countries;
      let obj = store.state.review.review_details.destination_id;

      console.log({ 'default': uaeId.value });
      console.log({ 'source_id': store.state.review.review_details.source_id });
      console.log({ 'destination_id': store.state.review.review_details.destination_id });
      console.log({ 'review': store.state.review });

      /*
      |--------------------------------------------------------------------------
      | Nationality
      |--------------------------------------------------------------------------
      | Do NOT exclude destination country.
      */

      if (_.type === 'nationality') {
        return allCountries;
      }

      /*
      |--------------------------------------------------------------------------
      | Existing Logic
      |--------------------------------------------------------------------------
      */

      const inbound_outbound = store.state.review.review_details?.inbound_outbound;

      if (store.state.review.review_details.source_id != uaeId.value) {

        /*
        |--------------------------------------------------------------------------
        | GTS Special Case
        |--------------------------------------------------------------------------
        */

        if (isGts.value == _.insuranceProviderId && _.inboundDestinationId == 99) {

          return allCountries;
        } else {

          return allCountries.filter((e) => {
            // Remove UAE
            if (e.id === uaeId.value) {
              return false;
            }
            // Remove selected destinations
            if (obj.includes(e.id)) {
              return false;
            }

            /*
            |--------------------------------------------------------------------------
            | Inbound to Lebanon
            |--------------------------------------------------------------------------
            | If travelling INTO Lebanon,
            | Lebanon should not appear in country of residence.
            */

            if (inbound_outbound === false && e.label?.toLowerCase() === 'lebanon') {
              return false;
            }
            return true;
          });

        }

      } else {

        return allCountries.filter((e) => {
          // Remove selected destinations
          if (obj.includes(e.id)) {
            return false;
          }
          // Inbound to Lebanon
          if (inbound_outbound === false &&  e.label?.toLowerCase() === 'lebanon') {
            return false;
          }
          return true;
        });
      }
    });
    
    const uaeId = computed(() => {
      return store.state.countries.uae_id;
    });

    onMounted(async () => {
      if(isMobile) {
          const nationality_teleport = document.getElementsByClassName('nationality_teleport')[0]
          nationality_ids.value = nationality_teleport.id

      }
    });


    const updateValue = (event) => {
      context.emit("update:modelValue", event);
      context.emit("change", event);
    };

    const nationality = ref()
    const isMobile = inject('isMobile')
    const nationality_ids = ref('')
    const nationality_search = ref('')


    const filtered_nationality = computed(() => {
      if(countries.value) {
        return countries.value.filter(obj => 
          obj.label.toString().toLowerCase().includes(nationality_search.value.toLowerCase())
        );
      }
      return []
    })

    const focus = () => {
      setTimeout(() => {
        nationality.value.focus()
      }, 500);
    }
    const colSize = (_.formProp == 'nationality_id') ? 'col-lg-12' : 'col-lg-12';
    return {
      nationality,
      colSize,
      focus,
      updateValue,
      countries,
      nationality_ids,
      nationality_search,
      isMobile,
      filtered_nationality
    };
  },
});
